import { Select, Input, Divider, Popover } from "antd";
import { chatModels } from "./ChatModels.config";
import { styled } from "styled-components";
import { useState, useEffect } from "react";
import ModelsInfo from "./ModelsInfo";
import { OpenaiIcon, SearchIcon } from "@dataone/icons";

const { Option } = Select;

const ChatModels = () => {
  const defaultSelectedKey = chatModels[8].key;
  const [searchText, setSearchText] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const filteredOptions = chatModels.filter((model) =>
    model.label.toLowerCase().includes(searchText.toLowerCase())
  );

  const dropdownRender = (menu: React.ReactNode) => (
    <StyledDropdownMenu>
      {filteredOptions.length === 0 ? (
        <div style={{ padding: "8px", textAlign: "center" }}>
          No options found
        </div>
      ) : (
        <StyledMenu>{menu}</StyledMenu>
      )}
      <StyledSearch>
        <StyledDatasetsDiver />
        <Input
          placeholder="Search Models..."
          value={searchText}
          maxLength={255}
          onChange={(e) => setSearchText(e.target.value)}
          prefix={
            <StyledSearchIcon>
              <SearchIcon />
            </StyledSearchIcon>
          }
          className="search-input"
        />
      </StyledSearch>
    </StyledDropdownMenu>
  );

  return (
    <StyledContainer>
      <div className="modal-container">
        {/* <div className="modal-icon"> */}
        {/* {model.icon} */}
        {/* <Styledicon>
          <OpenaiIcon />
        </Styledicon> */}

        {/* </div> */}
        <div className="modal-label">
          {/* {windowWidth < 1250
                ? `${model.label.slice(0, 12)}...`
                : model.label} */}
          {/* OpenAI integration */}
        </div>
      </div>
      {/* <CustomSelect
        defaultValue={defaultSelectedKey}
        suffixIcon={
          <img
            src="images/smart-search/chat/caret-up-fill-icon.svg"
            alt="Custom Arrow"
            className={windowWidth < 1200 ? "custom-arrow" : ""}
            style={{ display: "none" }}
          />
        }
        // dropdownRender={dropdownRender}
      > */}
      {/* {filteredOptions.map((model) => ( */}
      {/* <Option
           key={model.key} value={model.key} className="custom-option"
           > */}
      {/* <StyledPopover
              placement="rightTop"
              content={
                <ModelsInfo
                  label={model.label}
                  icon={model.icon}
                  description={model.description}
                  context={model.context}
                  Input={model.Input}
                  Output={model.Output}
                />
              }
              color="transparent"
            > */}
      {/* <div className="modal-container">
              <div className="modal-icon">{model.icon}</div>
              <div className="modal-label">
                {windowWidth < 1250
                  ? `${model.label.slice(0, 12)}...`
                  : model.label}
              </div>
            </div> */}
      {/* </StyledPopover> */}
      {/* </Option> */}
      {/* ))} */}
      {/* </CustomSelect> */}
    </StyledContainer>
  );
};

export default ChatModels;

const CustomSelect = styled(Select)`
  width: 18vw;
  min-width: 180px;
  .ant-select-selector {
    border-radius: 8px;
    background: #fff;
    padding: 15px;
    border: 1px solid #fff !important;
    min-width: 180px;
  }
  .custom-arrow {
    // position: fixed;
    // left: 200px;
  }
  .modal-container {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 12px;
    cursor: default;
  }
  .modal-icon {
    display: flex;
  }
`;

const StyledPopover = styled(Popover)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px;

  .modal-label {
    margin: 0px 0px 7px 10px;
  }
`;

const StyledContainer = styled.div`
  margin: 17px 0px 0px 36px;
  .modal-container {
    display: flex;
    gap: 10px;
    cursor: default;
  }
`;

const StyledSearch = styled.div`
  margin: 10px;
  ::placeholder {
    color: rgba(4, 7, 38, 0.7);
    font-size: 15px;
    font-weight: 400;
    letter-spacing: -0.225px;
  }
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
  .search-input {
    border: none;
    padding: 5px;
  }
`;

const StyledDatasetsDiver = styled(Divider)`
  border: 2px solid #bccbfb;
  margin-bottom: 7px;
  margin-top: 0px;
`;

const StyledDropdownMenu = styled.div`
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
`;

const StyledMenu = styled.div``;

const StyledSearchIcon = styled.div`
  margin-right: 6px;
  display: flex;
`;

const Styledicon = styled.div`
  display: flex;
  width: 15px;
  align-items: center;
  font-size: 18px;
`;
